import {serverBus} from '../main'
import ChatIcon from '../assets/chat-icon.svg'
const axios = require('axios')

export const closeWidget = {
  methods: {
    closeWidget: async function (reason, answer, actionName) {
      localStorage.removeItem('dataTotalAnswers')
      localStorage.removeItem('dataTotalCategory')
      localStorage.removeItem('dataHistory')
      var askWidget = document.querySelector('#app_ask')
      // askWidget.style.cssText = `opacity: 0; right: -3000px; z-index: -1; transition: opacity 0.33s linear;`
      askWidget.style.cssText = `right: -3000px`
      let uuId = localStorage.getItem('getUuid')
      if (this.$userUid || uuId) {
        let ask = {
          uid: this.$userUid ? this.$userUid : uuId,
          brand: this.$ask.brand,
          user_id: this.$ask.user_id,
          user_agent: navigator.userAgent
        }
        if (actionName) {
          ask['action'] = 'btn_close_feedback'
        } else {
          ask['action'] = 'btn_close_chat'
        }
        if (reason) ask.action = reason
        if (answer) ask.action_id = answer
        axios
          .post(this.$ask.url + '/api/ask/' + this.$settings.api_salt + '/close-widget-statistic', {ask})
        serverBus.$emit('closingWidget')
      }
      // sessionStorage.setItem('visibility_changed', 'maximized')
    },
    answerOnWidget: async function (ask) {
      axios
        .post(this.$ask.url + '/api/ask/' + this.$settings.api_salt + '/feedback-answer', {ask})
      serverBus.$emit('closingWidget')
    },
    hideWidget: function () {
      localStorage.setItem('stylesWidget', JSON.stringify({
        backgroundColor: this.$settings.block_background,
        color: this.settings.block_font
      }))
      var askWidget = document.querySelector('#app_ask')
      var mainBtnOfWidget = document.querySelector('.handle_show-chat')
      if (mainBtnOfWidget) {
        mainBtnOfWidget.style.cssText = `opacity: 0;  z-index: -1; pointer-events: none;`
      }
      var buttonHide = document.createElement('button')
      askWidget.style.cssText = `opacity: 0; right: -3000px; z-index: -1; transition: opacity 0.33s linear;`
      buttonHide.innerHTML = `<img style="width: 30px; height: 30px;" src=${ChatIcon} style="max-width:75%;">`
      buttonHide.className = 'btn-show-widget'
      buttonHide.style.cssText = `
        z-index: 1001;
        position: fixed;
        bottom: 75px;
        right: 10px;
        border: none;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        color: #fff;
        font-size: 29px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background-color: ${this.$settings.theme_color}
      `
      buttonHide.addEventListener('click', () => {
        var btnShowWidget = document.querySelector('.btn-show-widget')
        var askWidget = document.querySelector('#app_ask')
        var widgetBody = document.querySelector('.ask-widget__holder')
        if (mainBtnOfWidget) {
          mainBtnOfWidget.style.cssText = `opacity: 1;  z-index: 11; pointer-events: all;`
        }
        let {backgroundColor, color} = JSON.parse(localStorage.getItem('stylesWidget'))
        btnShowWidget.remove()
        askWidget.style.cssText = `opacity: 1; transition: opacity 500ms ease-in;`
        widgetBody.style.cssText = `
          background-color: ${backgroundColor};
          color: ${color}
        `
      })
      document.body.appendChild(buttonHide)
      // let pageWrap = document.querySelector('.page_wrap')
      // let asideOverlay = document.querySelector('.aside_overlay')
      // pageWrap.appendChild(buttonHide)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/closeWidget.js